import React ,{useRef}from 'react'
import NewNavbar from '../../components/NewNav'
import styled from 'styled-components';
import { Privacies } from '../../components/Objectarray';
import Layout from '../../Layout/Layout';
import Footer from '../../components/Footer';

function PrivacyPolicy() {

  return (

    <PrivacyWrapper>

          <NewNavbar
           
          />
          <List>

          {Privacies.map((m, i) => (
              <div className="list" key={i}>
                  <p>
                      {i + 1}. {m.title}
                  </p>
                  {/* <ul> */}
                  {m.word.map((k, l) => (
                      <ul key={l}>
                          <li>{k}</li>
                      </ul>
                  ))}
                  {/* </ul> */}
              </div>
          ))}
          <ContactResidify>
                  <p className="title">Contact Adashiesusuakawo</p>
              <ul>
                  <li>
                      Email: &nbsp;&nbsp;
                          <a href="mailto:tm30@adashi.com">tm30@adashi.com</a>
                  </li>
                  <li>
                      Website: &nbsp;&nbsp;
                      <a href="www.residify.ng">www.residify.ng</a>
                  </li>
                  <li>
                      Phone: &nbsp; ++2348182504430
                  </li>
              </ul>
          </ContactResidify>
          </List>
      
        <Footer/>
    </PrivacyWrapper>
  )
}

export default PrivacyPolicy;
const PrivacyWrapper = styled.div`
  margin: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
  `


const ContactResidify = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 20px;
  .title{
    color: #002DCC;
    font-size: 18px;
    font-weight: 500;
  }
  ul {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 5px;
    li {
    //   display: flex;
    //   align-items: center;
    //   gap: 10px;
      color: #121212;
      font-size: 16px;
      font-weight: 300;
      a{
          color: #121212;
          font-size: 14px;
          text-decoration: none;
          border-bottom: 1px solid;
        
      }
    }
  }
`;
const List = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 40px;
  width: 82%;
    @media screen and (max-width: 768px){
      width: 95%;
    }
  .list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 20px;
    width: 84%;
    @media screen and (max-width: 768px){
      width: 100%;
    }
    p {
      color: #002dcc;
      font-size: 18px;
      font-weight: 500;
    }

    ul {
      li {
        margin-left: 15px;
        color: #121212;
        font-size: 14px;
        font-weight: 300;
      }
    }
  }
`;